import { createPaginatedResource, type PaginationRouteResource } from '@atlassian/eoc-pagination';

import { getList } from '../../endpoints/list';

const listResource: PaginationRouteResource<{
	callResponders: {
		id: string;
		type: 'user' | 'team' | 'escalation' | 'schedule';
	}[];
	enabled: boolean;
	id: string;
	isAtlassianManagedNumber: boolean;
	name: string;
	phoneNumber: string;
}> = createPaginatedResource({
	type: 'getListResource',
	getKey: () => 'getListResource',
	getData: () => getList,
	isBrowserOnly: true,
});

export { listResource };
